module.exports = __webpack_public_path__ + "resources/img/open_stack.5cd30b6d06011cb87da3a151afab7673.png";